"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var chunked_blob_reader_1 = require("@aws-sdk/chunked-blob-reader");
exports.blobHasher = function blobHasher(hashCtor, blob) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var hash;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    hash = new hashCtor();
                    return [4 /*yield*/, chunked_blob_reader_1.blobReader(blob, function (chunk) {
                            hash.update(chunk);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, hash.digest()];
            }
        });
    });
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/hash-blob-browser/build/index.js
// module id = 4Va5
// module chunks = 0